module.exports = __webpack_public_path__ + "static/media/hero_img_about_us.88b2aab8.png";